import {EnvironmentProviders, ErrorHandler, importProvidersFrom, makeEnvironmentProviders} from '@angular/core';
import {provideRouter} from '@angular/router';
import 'quill/modules/history';
import {routes} from './app.routes';
import {en_US, provideNzI18n} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {FormsModule} from '@angular/forms';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {HasuraHttp, KlnHasura, MosHasura} from './core/hasura-client';
import {authInterceptor} from './core/auth.interceptor';
import {OrdsHttp} from './core/ords-client';
import {AppErrorHandler} from './core/app-error-handler';

registerLocaleData(en);

export function provideMonaco(): EnvironmentProviders {
  const baseUrl = 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.0/min/vs';
  (window as any).require.config({paths: {vs: baseUrl,},});
  (window as any).require(['vs/editor/editor.main'], () => {
  });
  return makeEnvironmentProviders([{provide: 'Editor', useValue: 'config'}]);
}

export const appConfig: any = {
  providers: [
    provideRouter(routes),
    provideNzI18n(en_US),
    provideMonaco(),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {provide: MosHasura},
    {provide: KlnHasura},
    OrdsHttp,
  ]
};
